/* eslint-disable */
let idTmr;
const getExplorer = () => {
	let explorer = window.navigator.userAgent;
	//ie
	if (explorer.indexOf("MSIE") >= 0) {
		return 'ie';
	}
	//firefox
	else if (explorer.indexOf("Firefox") >= 0) {
		return 'Firefox';
	}
	//Chrome
	else if (explorer.indexOf("Chrome") >= 0) {
		return 'Chrome';
	}
	//Opera
	else if (explorer.indexOf("Opera") >= 0) {
		return 'Opera';
	}
	//Safari
	else if (explorer.indexOf("Safari") >= 0) {
		return 'Safari';
	}
}
// 判断浏览器是否为IE
const exportToExcel = (data, name) => {

	// 判断是否为IE
	if (getExplorer() == 'ie') {
		tableToIE(data, name)
	} else {
		tableToNotIE(data, name)
	}
}

const Cleanup = () => {
	window.clearInterval(idTmr);
}

// ie浏览器下执行
const tableToIE = (data, name) => {
	let curTbl = data;
	let oXL = new ActiveXObject("Excel.Application");

	//创建AX对象excel
	let oWB = oXL.Workbooks.Add();
	//获取workbook对象
	let xlsheet = oWB.Worksheets(1);
	//激活当前sheet
	let sel = document.body.createTextRange();
	sel.moveToElementText(curTbl);
	//把表格中的内容移到TextRange中
	sel.select;
	//全选TextRange中内容
	sel.execCommand("Copy");
	//复制TextRange中内容
	xlsheet.Paste();
	//粘贴到活动的EXCEL中

	oXL.Visible = true;
	//设置excel可见属性

	try {
		let fname = oXL.Application.GetSaveAsFilename("Excel.xls", "Excel Spreadsheets (*.xls), *.xls");
	} catch (e) {
		print("Nested catch caught " + e);
	} finally {
		oWB.SaveAs(fname);

		oWB.Close(savechanges = false);
		//xls.visible = false;
		oXL.Quit();
		oXL = null;
		// 结束excel进程，退出完成
		window.setInterval("Cleanup();", 1);
		idTmr = window.setInterval("Cleanup();", 1);
	}
}

// 非ie浏览器下执行
const tableToNotIE = (function() {
	// 编码要用utf-8不然默认gbk会出现中文乱码
	const uri = 'data:application/vnd.ms-excel;base64,',
		template =
		'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';

	const base64 = function(s) {
		return window.btoa(unescape(encodeURIComponent(s)));
	}

	const format = (s, c) => {
		return s.replace(/{(\w+)}/g,
			(m, p) => {
				return c[p];
			})
	}

	return (table, name) => {
		const ctx = {
			worksheet: name,
			table
		}

		const url = uri + base64(format(template, ctx));

		if (navigator.userAgent.indexOf("Firefox") > -1) {
			window.location.href = url
		} else {
			const aLink = document.createElement('a');
			aLink.href = url;
			aLink.download = name || '';
			let event;
			if (window.MouseEvent) {
				event = new MouseEvent('click');
			} else {
				event = document.createEvent('MouseEvents');
				event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false,
					false, 0, null);
			}
			aLink.dispatchEvent(event);
		}
	}
})()

// 导出函数
const table2excel = async (column, data, excelName) => {
	const typeMap = {
		image: getImageHtml,
		text: getTextHtml
	}

	let thead = column.reduce((result, item) => {
		result += `<th>${item.title}</th>`
		return result
	}, '')

	thead = `<thead><tr style="
	background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
	background: -o-linear-gradient(#3da5d9, #a2d2ff);
	background: -moz-linear-gradient(#3da5d9, #a2d2ff);
	background: linear-gradient(#3da5d9, #a2d2ff);
	text-align: center;
	color: #000000;
	font-size: 16px;
	font-weight: 500;" >${thead}</tr></thead>`
	var tbody = ``
	for (var item of data) {
		var temp = ``
		for (var item1 of column) {
			temp += await typeMap[item1.type || 'text'](item[item1.key], item1)
		}
		tbody += `<tr>${temp}</tr>`
	}

	tbody =
		`<tbody border='1'  style='border-bottom:none;border-left:none;border-right:none;border-top:none;'>${tbody}</tbody>`

	const table = thead + tbody
	// console.log(table)
	// 导出表格
	exportToExcel(table, excelName)

	function getTextHtml(val) {
		return new Promise((resolve, reject) => {
			let t = '';
			t = val;
			if (String(t).substring(0, 1) != '0' && (!isNaN(parseFloat(t)) && isFinite(t))) {
				// console.log('数字=' + t);
				t = `<td style="text-align: center;">${val}</td>`
			} else {
				t = `<td style="text-align: center;vnd.ms-excel.numberformat:@">${val}</td>`
			}

			resolve(t);
		})
		// return `<td style="text-align: center;vnd.ms-excel.numberformat:@">${val}</td>`
	}

	function imgUrlToBase64(url) {
		// console.log('url=' + url);
		return new Promise((resolve, reject) => {
			if (!url) {
				resolve('')
			}
			if (/\.(png|jpe?g|gif|svg)(\?.*)?$/.test(url)) {
				// 图片地址 多图下载太慢了，不确定原因
				// 同样20行带图表格导出，用转换为base64达到15.7M 不建议
				// const image = new Image()
				// 设置跨域问题

				// image.setAttribute('crossOrigin', 'anonymous')
				// // image.setAttribute('crossOrigin', '*')
				// // 图片地址
				// image.src = url;
				// // image.crossOrigin = "anonymous"
				// image.onload = () => {
				// 	const canvas = document.createElement('canvas')
				// 	const ctx = canvas.getContext('2d')
				// 	canvas.width = image.width
				// 	canvas.height = image.height
				// 	ctx.drawImage(image, 0, 0, image.width, image.height)
				// 	// 获取图片后缀
				// 	const ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase()
				// 	// 转base64
				// 	const dataUrl = canvas.toDataURL(`image/${ext}`)
				// 	resolve(dataUrl || '')
				// }

				// 下载本地内容可以，并且正常导出
				// 同样20行带图表格导出只有3.7M
				let xhr = new XMLHttpRequest()
				xhr.open('get', url, true)
				xhr.responseType = 'blob'
				xhr.onload = function() {
					if (this.status == 200) {
						let blob = this.response
						let oFileReader = new FileReader()
						oFileReader.onloadend = function(e) {
							const base64 = e.target.result
							resolve(base64)
						}
						oFileReader.readAsDataURL(blob)
					}
				}
				xhr.send()


			} else {
				// 非图片地址
				resolve('非(png/jpe?g/gif/svg等)图片地址');
			}
		})

	}

	// function getImageHtml(val, options) {
	// 	console.log(val);
	// 	return new Promise((resolve, reject) => {
	// 		imgUrlToBase64(val[0]).then(res => {
	// 			// console.log(res);
	// 			options = Object.assign({
	// 				width: 60,
	// 				height: 60
	// 			}, options)
	// 			resolve(
	// 				`<td style="width: ${options.width}px; height: ${options.height}px; text-align: center; vertical-align: middle"><img  src="${res}" width=${options.width} height=${options.height}></td>`
	// 				)
	// 		}).catch(e => {
	// 			resolve(e)
	// 		})
	// 	})
	// }

	// 直接放img 还是一例
	// async function getImagedata(src, options) {
	// 	let img_src = await imgUrlToBase64(src);
	// 	// console.log('图片大小=' + img_src.length);
	// 	let img = '';
	// 	options = Object.assign({
	// 		width: 50,
	// 		height: 50
	// 	}, options)

	// 	img = `<img  src="${img_src}" width=${options.width} height=${options.height}>`

	// 	return img;
	// }

	// async function getImageHtml(val, options) {
	// 	// console.log(val);
	// 	options = Object.assign({
	// 		width: 60,
	// 		height: 60
	// 	}, options)
	// 	// console.log(val)
	// 	const valList = val

	// 	let tdStr = '';
	// 	let num = 0,
	// 		w = 0,
	// 		h = 0;
	// 	for (let i = 0; i < valList.length; i++) {
	// 		tdStr += await getImagedata(valList[i]);
	// 		num++;
	// 	}
	// 	num = options.width * num;
	// 	w = options.width;
	// 	h = options.height;
	// 	// console.log('num=' + num);
	// 	tdStr =
	// 		'<td style="width:' + num + 'px;height:' + h + 'px; text-align:center;vertical-align:middle">' +
	// 		tdStr + '</td>';

	// 	console.log(tdStr);
	// 	return tdStr
	// }

	// 用div 包含不行，还是一例
	// async function getImagedata(src, options) {
	// 	let img_src = await imgUrlToBase64(src);
	// 	// console.log('图片大小=' + img_src.length);
	// 	let img = '';
	// 	options = Object.assign({
	// 		width: 50,
	// 		height: 50
	// 	}, options)

	// 	img = `<div style="display:inline-flex;align-items:center;justify-content:center;" ><img  src="${img_src}" width=${options.width} height=${options.height}></div>`

	// 	return img;
	// }

	// async function getImageHtml(val, options) {
	// 	// console.log(val);
	// 	options = Object.assign({
	// 		width: 60,
	// 		height: 60
	// 	}, options)
	// 	// console.log(val)
	// 	const valList = val

	// 	let tdStr = '';
	// 	let num = 0,
	// 		w = 0,
	// 		h = 0;
	// 	for (let i = 0; i < valList.length; i++) {
	// 		tdStr += await getImagedata(valList[i]);
	// 		num++;
	// 	}
	// 	num = options.width * num;
	// 	w = options.width;
	// 	h = options.height;
	// 	// console.log('num=' + num);
	// 	tdStr =
	// 		'<td style="width:' +
	// 		num + 'px;height:' + h + 'px; text-align:center;vertical-align:middle"><div style="display:flex;flex-direction:row;justify-content:space-around;align-items:center;">' +
	// 		tdStr + '</div></td>';

	// 	console.log(tdStr);
	// 	return tdStr
	// }


	// 直接用td包含img 是一行了，但是会覆盖后面的，所以图片列得是最后的
	async function getImagedata(src, options) {
		let img_src = await imgUrlToBase64(src);
		// console.log('图片大小=' + img_src.length);
		let img = '';
		options = Object.assign({
			width: 50,
			height: 50
		}, options)

		img =
			`<td style="width: 60px; height: 60px; text-align: center; vertical-align: middle"><div style="display:inline-flex;align-items:center;justify-content:center;" ><img  src="${img_src}" width=${options.width} height=${options.height}></div></td>`

		return img;
	}

	async function getImageHtml(val, options) {
		// console.log(val);
		options = Object.assign({
			width: 60,
			height: 60
		}, options)
		// console.log(val)
		const valList = val

		let tdStr = '';

		for (let i = 0; i < valList.length; i++) {
			tdStr += await getImagedata(valList[i]);
		}
		// console.log(tdStr);
		return tdStr
	}




}

export default table2excel